import { useEffect, useState } from "react";
import "../App.css";
import ExcelChart from "../Chart/Chart";
import QuantStrip, { QUANT_STRIP_HEIGHT } from "../Chart/QuantStrip";
import QuantPanel from "../Chart/QuantPanel";
import useIsMobile from "../Chart/useIsMobile";

const STRIP_GAP = 8;
const PANEL_KEY = "lwt.quantPanelOpen";

export default function ChartPage({ workspace = "chart" }) {
  const [themeMode, setThemeMode] = useState("instrument");
  const isMobile = useIsMobile();
  const [panelOpen, setPanelOpen] = useState(() => {
    try {
      return window.localStorage.getItem(PANEL_KEY) !== "0";
    } catch {
      return true;
    }
  });
  useEffect(() => {
    try {
      window.localStorage.setItem(PANEL_KEY, panelOpen ? "1" : "0");
    } catch {
      // storage blocked: the panel just opens by default next time
    }
  }, [panelOpen]);

  // Chart.js sizes its shell against the viewport; this offset accounts for the
  // quant strip and chart toolbar inside the full-height tab below the site nav.
  const topOffset = isMobile ? 0 : QUANT_STRIP_HEIGHT + STRIP_GAP + 8;

  return (
    <div className={`App theme-${themeMode}`} style={{ height: "100%", minHeight: 0, display: "flex", flexDirection: "column", overflow: "hidden" }}>
      <div className="app-shell" style={{ height: "100%", minHeight: 0, flex: 1, padding: 0, boxSizing: "border-box" }}>
        <div className="app-glow app-glow-left" />
        <div className="app-glow app-glow-right" />
        <main className="app-panel" style={{ height: "100%", minHeight: 0, width: "100%", maxWidth: 1920, margin: "0 auto", padding: 0, border: 0, boxSizing: "border-box", display: "flex", flexDirection: "column" }}>
          {!isMobile && (
            <div style={{ flex: "0 0 auto", marginBottom: STRIP_GAP }}>
              <QuantStrip panelOpen={panelOpen} onTogglePanel={() => setPanelOpen((v) => !v)} />
            </div>
          )}
          <div style={{ display: "flex", flex: 1, minHeight: 0, gap: 8, alignItems: "stretch" }}>
            <div style={{ flex: "1 1 0", minWidth: 0, minHeight: 0, height: "100%" }}>
              <ExcelChart themeMode={themeMode} onThemeChange={setThemeMode} shellTopOffset={topOffset} workspace={workspace} />
            </div>
            {!isMobile && panelOpen && <QuantPanel height={`calc(100vh - ${48 + topOffset}px)`} />}
          </div>
        </main>
      </div>
    </div>
  );
}
